@if(checkValidApps()){
  <div class="mt-1">
    Please publish applications to add scope.
  </div>

}@else{
<form [formGroup]="form">
  <div class="applications-section mt-3" formArrayName="entries">

    <div *ngFor="let group of formArray.controls; let i = index" [formGroupName]="i">
      <div class="row align-items-center mb-2">
        <div class="col-md-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Application</mat-label>
            <mat-select formControlName="application" [compareWith]="compareApps">
              <mat-option *ngFor="let app of getAvailableApplications(i) " [value]="app?.applicationId">
                {{ app?.applicationName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Resource</mat-label>
            <mat-select formControlName="resource" multiple>
              <mat-option *ngFor="let res of userPermissionresourseList[applicationName]?.resources"
                [value]="res?.resourceName">
                {{ res?.resourceName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-2 d-flex gap-2">
          <button mat-icon-button color="warn" (click)="deleteEntry(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="row align-items-center mt-3">
      <div class="col-md-10">
        <button mat-raised-button color="primary" class="w-100" (click)="addEntry()" [hidden]="this.validNoApps === formArray.length" [disabled]="!canAddNewEntry()">
          Add Entry
        </button>
      </div>
    </div>
  </div>
</form>
}
